'use strict';

import incidenceRates from './incidence-rates';
import moment from 'moment';

const dataHandler = (function(){

    function calculateRegionFirstDayCounts(data) {
        const firstDate = window.config.firstDate;
        const dateString = firstDate.format('YYYY-MM-DD');
        if (typeof data.firstDayCounts === 'undefined' || typeof data.firstDayCounts[dateString] === 'undefined') {
            const firstDateCounts = {
                count: data.count,
                firstDayCount: 0,
                areas: data.areas.reduce(function(obj, item) {
                    obj[item.id] = JSON.parse(JSON.stringify(item));
                    obj[item.id].firstDayCount = 0;
                    return obj;
                }, {})
            };

            for (let idx = 0; idx < data.days.length; idx++) {
                const day = data.days[idx];
                const date = moment(day.date);
                if (date <= firstDate) { // First day is 0
                    // Add to total
                    firstDateCounts.firstDayCount += day.dayCount;

                    // Add area values
                    for (let area of data.areaDays[idx].areas) {
                        let areaData = data.areas[area.index];
                        if (typeof firstDateCounts.areas[areaData.id] !== 'undefined') {
                            firstDateCounts.areas[areaData.id].firstDayCount += area.dayCount;
                        }
                    }

                } else {
                    // This is where we stop
                    break;
                }
            }

            // Save rate infos that have been done
            if (typeof data.firstDayCounts === 'undefined') {
                data.firstDayCounts = {};
            }
            data.firstDayCounts[dateString] = firstDateCounts;
        }
    }

    function calculateRegionTotalCounts(data) {
        let totalCount = 0;
        const areaTotals = {};

        for (let idx = 0; idx < data.days.length; idx++) {
            const day = data.days[idx];
            const areaDay = data.areaDays[idx];

            // Day total
            totalCount += day.dayCount;
            day.totalCount = totalCount;

            // Total for each area
            for (const area of areaDay.areas) {
                const areaData = data.areas[area.index];

                if (typeof areaTotals[areaData.id] === 'undefined') {
                    areaTotals[areaData.id] = 0;
                }

                areaTotals[areaData.id] += area.dayCount;
                area.totalCount = areaTotals[areaData.id];
            }
        }
    }

    function calclulateRegionIncidenceRates(regions) {
        incidenceRates.region(regions, window.config.firstDate, window.config.rateDays);
    }

    function calculateMunicipalityIncidenceRates(data, chartFirstDate, selectedIds) {
        incidenceRates.municipality(data, chartFirstDate, window.config.rateDays, selectedIds);
    }

    function updateRegions(data) {
        if (!data.confirmed.updated) {
            // Calculate total counts for each day
            calculateRegionTotalCounts(data.confirmed);
            // Get rate values for each area
            calclulateRegionIncidenceRates(data.confirmed);
            // Calculate Region first day counts
            calculateRegionFirstDayCounts(data.confirmed);
            data.confirmed.updated = true;
        }
    }

    function getChartFirstDate(date = window.config.firstDate) {
        const dataFirstDate = typeof date === 'string' ? moment(date) : date;
        const chartFirstDate = window.config.firstDate < dataFirstDate ? dataFirstDate : window.config.firstDate;
        chartFirstDate.set({
            hour: 0,
            minute: 0,
            second: 0
        });

        return chartFirstDate;
    }

    function getChartStartDate(data, date = null) {
        const dataArr = Array.isArray(data) ? data : Object.values(data);
        const firstDay = date ? date : dataArr[0].days[0].date;
        const chartFirstDate = getChartFirstDate(firstDay);

        return {
            chartFirstDate,
            dataArr
        }
    }

    function setFirstDayValues(data, date = null) {
        const { chartFirstDate, dataArr } = getChartStartDate(data, date);

        for (let item of dataArr) {
            if (!item.firstDayValue) {
                // Get the first day value
                let firstDayValue = 0;
                for (const day of item.days) {
                    const newDate = moment(day.date);
                    newDate.set({
                        hour: 0,
                        minute: 0,
                        second: 0
                    });

                    if (newDate >= chartFirstDate) {
                        firstDayValue = day.count;
                        break;
                    }
                }

                item.firstDayValue = firstDayValue;
            }
        }

        return chartFirstDate;
    }

    function setAgeDataPerDay(data) {
        if (typeof data.agesPerDay === 'undefined' || data.agesPerDay < data.ages[0].days.length) {
            data.agesPerDay = [];

            for (let age of data.ages) {
                let idx = 0;
                for (let day of age.days) {
                    if (idx - 1 >= 0) {
                        let dayIdx = idx - 1;
                        if (typeof data.agesPerDay[dayIdx] === 'undefined') {
                            data.agesPerDay.push({
                                totalCount: 0,
                                count: 0,
                                date: day.date,
                                ages: []
                            });
                        }

                        let dayCount = day.count - age.days[idx-1].count; // Current day value only
                        dayCount = dayCount > 0 ? dayCount : 0; // Stay positive

                        data.agesPerDay[dayIdx].totalCount += day.count;
                        data.agesPerDay[dayIdx].count += dayCount;
                        data.agesPerDay[dayIdx].ages.push({
                            name: age.name,
                            slug: age.slug,
                            count: dayCount,
                            totalCount: day.count
                        })
                    }
                    idx++;
                }
            }
        }
    }

    return {
        updateRegions,
        calculateRegionFirstDayCounts,
        calclulateRegionIncidenceRates,
        calculateMunicipalityIncidenceRates,
        getChartFirstDate,
        setFirstDayValues,
        setAgeDataPerDay,
        getChartStartDate
    }
})();

export default dataHandler;
